export { default } from './EditFullScreen.tsx'
